<template>
  <div :class="legendClasses" data-testid="crossed-materiality-legend">
    <div class="legend-item d-flex align-center gap-1" data-testid="crossed-materiality-legend__local-control">
      <v-icon :class="localControlClass" id="l_c_m_c_pro">mdi-circle</v-icon>
      <span v-if="showLabels" :class="['crossed-text', { 'grey--text text--lighten-1': !localControlCrossed }]">
        Local Control Materiality {{ localControlCrossed ? 'crossed' : 'not crossed' }}
      </span>
    </div>
    <div class="legend-item d-flex align-center gap-1" data-testid="crossed-materiality-legend__local-management">
      <v-icon :class="localManagementClass" id="l_m_m_c_pro">mdi-circle</v-icon>
      <span v-if="showLabels" :class="['crossed-text', { 'grey--text text--lighten-1': !localManagementCrossed }]">
        Local Management Materiality {{ localManagementCrossed ? 'crossed' : 'not crossed' }}
      </span>
    </div>
    <div class="legend-item d-flex align-center gap-1" data-testid="crossed-materiality-legend__regional-control">
      <v-icon :class="regionalControlClass" id="r_c_m_c_pro">mdi-record-circle-outline</v-icon>
      <span v-if="showLabels" :class="['crossed-text', { 'grey--text text--lighten-1': !regionalControlCrossed }]">
        Regional Control Materiality {{ regionalControlCrossed ? 'crossed' : 'not crossed' }}
      </span>
    </div>
    <div class="legend-item d-flex align-center gap-1" data-testid="crossed-materiality-legend__regional-management">
      <v-icon :class="regionalManagementClass" id="r_m_m_c_pro">mdi-record-circle-outline</v-icon>
      <span v-if="showLabels" :class="['crossed-text', { 'grey--text text--lighten-1': !regionalManagementCrossed }]">
        Regional Management Materiality {{ regionalManagementCrossed ? 'crossed' : 'not crossed' }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CrossedMaterialityLegend',
  props: {
    showLabels: {
      type: Boolean,
      default: true,
    },
    /** Flag indicating if local control materiality is crossed */
    localControlCrossed: {
      type: Boolean,
      default: false,
    },
    /** Flag indicating if local management materiality is crossed */
    localManagementCrossed: {
      type: Boolean,
      default: false,
    },
    /** Flag indicating if regional control materiality is crossed */
    regionalControlCrossed: {
      type: Boolean,
      default: false,
    },
    /** Flag indicating if regional management materiality is crossed */
    regionalManagementCrossed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    legendClasses() {
      return [
        'crossed-materiality-legend',
        { 'crossed-materiality-legend--icons-only': !this.showLabels },
      ];
    },
    /** Class for local control icon - red when crossed, grey when not */
    localControlClass() {
      return this.localControlCrossed ? 'error--text' : 'grey--text text--lighten-1';
    },
    /** Class for local management icon - blue when crossed, grey when not */
    localManagementClass() {
      return this.localManagementCrossed ? 'blue--text' : 'grey--text text--lighten-1';
    },
    /** Class for regional control icon - red when crossed, grey when not */
    regionalControlClass() {
      return this.regionalControlCrossed ? 'error--text' : 'grey--text text--lighten-1';
    },
    /** Class for regional management icon - blue when crossed, grey when not */
    regionalManagementClass() {
      return this.regionalManagementCrossed ? 'blue--text' : 'grey--text text--lighten-1';
    },
  },
};
</script>

<style scoped>
.crossed-materiality-legend {
  display: grid;
  grid-template-columns: 2fr 2fr;
  column-gap: 10px;
  row-gap: 8px;
}

.crossed-materiality-legend--icons-only {
  display: flex;
  align-items: center;
  gap: 8px;
}

.legend-item .v-icon {
  font-size: var(--font-size-xs) !important;
  margin: 1px 1px !important;
}

.crossed-text {
  font-size: var(--font-size-xs);
}
</style>
